import { getAuthHeader } from "./authService";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/v1/productos`;

/* ===== Helpers ===== */
const toJson = async (res) => {
  try {
    return await res.json();
  } catch (e) {
    console.warn("[PRODUCTOS][WARN] No se pudo parsear JSON", e);
    return {};
  }
};

const ensureOk = (res, data) => {
  if (!res.ok) {
    const msg =
      data?.message ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }
};

const clean = (obj) => {
  const out = {};
  Object.entries(obj || {}).forEach(([k, v]) => {
    if (v === undefined || v === null) return;
    if (typeof v === "string" && v.trim() === "") return;
    out[k] = v;
  });
  return out;
};

/** GET /api/productos */
export async function listProductos() {
  const res = await fetch(BASE_URL, {
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  const data = await toJson(res);
  ensureOk(res, data);
  return Array.isArray(data) ? data : data?.data ?? [];
}

/** GET /api/productos/:id */
export async function getProductoById(id) {
  if (!id) throw new Error("ID es requerido");
  const res = await fetch(`${BASE_URL}/${id}`, {
    headers: { Accept: "application/json", ...getAuthHeader() },
  });
  if (res.status === 404) return null;
  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}

/** POST /api/productos */
export async function createProducto(form) {
  const payload = clean({
    nombre: form.nombre,
    descripcion: form.descripcion,
    monto: form.monto,
    activo: form.activo === undefined ? true : form.activo,
  });

  const res = await fetch(BASE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(payload),
  });

  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}

/** PUT /api/productos/:id */
export async function updateProducto(id, form) {
  if (!id) throw new Error("ID es requerido para actualizar");

  const payload = clean({
    nombre: form.nombre,
    descripcion: form.descripcion,
    monto: form.monto,
    activo: form.activo,
  });

  const res = await fetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      ...getAuthHeader(),
    },
    body: JSON.stringify(payload),
  });

  const data = await toJson(res);
  ensureOk(res, data);
  return data?.data ?? data;
}

/** DELETE /api/productos/:id */
export async function deleteProducto(id) {
  if (!id) throw new Error("ID es requerido para eliminar");

  const res = await fetch(`${BASE_URL}/${id}`, {
    method: "DELETE",
    headers: { Accept: "application/json", ...getAuthHeader() },
  });

  const data = await toJson(res);
  ensureOk(res, data);
  return true;
}
